import { Button, ButtonProps, ConfigProvider } from 'antd';
import clsx from 'clsx';
import { CloseIcon } from '../../icons/close-icon';
import { HamburgerIcon } from '../../icons/hamburger-icon';
import styles from './hamburger-button.module.css';

interface Props {
  buttonProps: ButtonProps;
  isOpened: boolean;
  isDisabled: boolean;
  extraMargin: boolean;
  changeIcon: boolean;
}

const HamburgerButton = ({ buttonProps, isOpened, isDisabled, extraMargin, changeIcon }: Props): JSX.Element => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorPrimaryHover: '#000000',
            colorPrimaryActive: '#000000',
            colorBgContainerDisabled: 'transparent',
          },
        },
      }}
    >
      <Button
        className={clsx(styles.hamburgerContainer, {
          [styles.active]: isOpened,
          [styles.extraMargin]: extraMargin,
        })}
        disabled={isDisabled}
        {...buttonProps}
      >
        {!changeIcon || (changeIcon && !isOpened) ? <HamburgerIcon /> : <CloseIcon />}
      </Button>
    </ConfigProvider>
  );
};

export default HamburgerButton;
